export const editModeState = {
    defaultState: {
        editMode: false,
    },
    actions: {
        startEditMode: (_, state) => ({...state, editMode: true}),
        stopEditMode: (_, state) => ({...state, editMode: false}),
    },
}
